/**
 * @generated SignedSource<<5069b1b49714552a977f06f7c2dc5a32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectTypePicker_projectsDirectoryV3$data = {
  readonly allJiraProjectTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly key: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "projectTypePicker_projectsDirectoryV3";
};
export type projectTypePicker_projectsDirectoryV3$key = {
  readonly " $data"?: projectTypePicker_projectsDirectoryV3$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectTypePicker_projectsDirectoryV3">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "projectTypePicker_projectsDirectoryV3",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraProjectTypeDetailsConnection",
      "kind": "LinkedField",
      "name": "allJiraProjectTypes",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraProjectTypeDetailsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraProjectTypeDetails",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "key"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "f75b948f55a1e98fe58f7b24532671ea";

export default node;
